import { fetchData, FetchOptions } from '@/lib/fetch-data';

type Params = FetchOptions & { uri: string };

export async function loadSearchData<T>({ uri, ...rest }: Params) {
  return fetchData<T>(`${process.env.NEXT_PUBLIC_SEARCH_API_URL}${uri}`, {
    ...rest,
  });
}
